import {XauditModel} from '../../xaudit.model';

export class NotificationToFrontOperatoryDataModel extends XauditModel {
  NoteToFrontOpID: string;
  NoteToFrontApptID: string;
  OperatoryId: string;
  OperatoryName: string;
}
